<div style="text-align:center">
 <h1>
  {{title}}
 </h1>
</div>
<router-outlet></router-outlet>



// WEBPACK FOOTER //
// C:/Users/BHAJ/Desktop/dribbler/src/app/app.component.html